import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import { withIcon } from '../../../core/components/Icon.tsx';
import classnames from '../../../core/utils/classnames.tsx';

const CheckIcon = withIcon(faCheck);

export const ConnectionIndicator = ({
    isConnected,
    className,
    ...props
}: { isConnected: boolean } & React.ComponentPropsWithRef<'div'>) => (
    <div className={classnames('relative flex items-center justify-center w-6', className)} {...props}>
        <div
            className={classnames(
                'w-full border-t-2 border-dotted',
                isConnected ? 'border-green-500' : 'border-neutral-stroke-accessible opacity-40'
            )}
        />
        {isConnected && (
            <div className="absolute flex items-center justify-center w-4 h-4 bg-green-600 rounded-full">
                <CheckIcon className="text-[8px] text-white" />
            </div>
        )}
    </div>
);
